import { SvgCcMastercard } from '@cocoonspace/icons/react/font-awesome/brands/cc-mastercard'
import { SvgCcVisa } from '@cocoonspace/icons/react/font-awesome/brands/cc-visa'
import { SvgCreditCard } from '@cocoonspace/icons/react/font-awesome/light/credit-card'
import type { SVGProps } from 'react'

export const PaymentMethodCardIcon = ({
	brand,
	...props
}: { brand?: string } & SVGProps<SVGSVGElement>) => {
	if (brand === 'visa') return <SvgCcVisa {...props} />
	else if (brand === 'mastercard') return <SvgCcMastercard {...props} />
	else return <SvgCreditCard {...props} />
}
